let folder = 'company/career'
export const state = () => ({
  meta: null,
  stage: null,
  content: null,
  jobs: null,
  whoWeAre: null,
  whatWeDo: null,
  closerLook: null,
  recommendations: null,
  benefits: null,
  offers: null,
  coffeeChat: null
  // kenjoJobs: []
  // relatedJobs: []
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  content(state) {
    return state.content
  },
  jobs(state) {
    return state.jobs
  },
  whoWeAre(state) {
    return state.whoWeAre
  },
  whatWeDo(state) {
    return state.whatWeDo
  },
  closerLook(state) {
    return state.closerLook
  },
  recommendations(state) {
    return state.recommendations
  },
  benefits(state) {
    return state.benefits
  },
  offers(state) {
    return state.offers
  },
  coffeeChat(state) {
    return state.coffeeChat
  }
  // kenjoJobs(state) {
  //   return state.kenjoJobs
  // }
  // relatedJobs(state) {
  //   return state.relatedJobs
  // }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setContent(state, { data }) {
    state.content = data
  },
  setJobs(state, { data }) {
    state.jobs = data
  },
  setWhoWeAre(state, { data }) {
    state.whoWeAre = data
  },
  setWhatWeDo(state, { data }) {
    state.whatWeDo = data
  },
  setCloserLook(state, { data }) {
    state.closerLook = data
  },
  setRecommendations(state, { data }) {
    state.recommendations = data
  },
  setBenefits(state, { data }) {
    state.benefits = data
  },
  setOffers(state, { data }) {
    state.offers = data
  },
  setCoffeeChat(state, { data }) {
    state.coffeeChat = data
  }
  // setRelatedJobs(state, { data, reset }) {
  //   if (reset) {
  //     state.relatedJobs = []
  //   } else {
  //     let mappedJobFolders = state.relatedJobs.map((relatedJob) => {
  //       return relatedJob.generic.folder
  //     })
  //     if (!mappedJobFolders.includes(data.generic.folder)) {
  //       state.relatedJobs.push(data)
  //     }
  //   }
  // }
  // setKenjoJobs(state, { data }) {
  //   state.kenjoJobs = data.filter((job) => {
  //     return job.companyName == 'Digitl GmbH'
  //   })
  // }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContent({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/content.json`)
      .then((res) => {
        commit('setContent', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getJobs({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/jobs.json`)
      .then((res) => {
        commit('setJobs', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getWhoWeAre({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/who_we_are.json`)
      .then((res) => {
        commit('setWhoWeAre', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getWhatWeDo({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/what_we_do.json`)
      .then((res) => {
        commit('setWhatWeDo', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getCloserLook({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/closer_look.json`)
      .then((res) => {
        commit('setCloserLook', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getRecommendations({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/recommendations.json`)
      .then((res) => {
        commit('setRecommendations', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getBenefits({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/benefits.json`)
      .then((res) => {
        commit('setBenefits', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getOffers({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/offers.json`)
      .then((res) => {
        commit('setOffers', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getCoffeeChat({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/coffee_chat.json`)
      .then((res) => {
        commit('setCoffeeChat', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  // getRelatedJobs({ commit, rootState }, { folderName }) {
  //   return this.$axios
  //     .get(
  //       `${rootState.language}/homepage/${folder}/${folderName}/content.json`
  //     )
  //     .then((res) => {
  //       res.data.generic.folder = folderName
  //       commit('setRelatedJobs', { data: res.data })
  //     })
  //     .catch((err) => {
  //       console.error(err)
  //     })
  // },
  // getKenjoJobs({ commit }) {
  //   return (
  //     // 'https://api.kenjo.io/company-career-site-db/public/digitlgroup?language=de',
  //     this.$axios
  //       .get('https://api.kenjo.io/company-career-site-db/public/digitlgroup', {
  //         headers: {
  //           'Content-Type': 'application/json;charset=UTF-8'
  //         }
  //       })
  //       .then((res) => {
  //         if (res.data.activePositions) {
  //           commit('setKenjoJobs', { data: res.data.activePositions })
  //         }
  //       })
  //       .catch((err) => {
  //         console.error(err)
  //       })
  //   )
  // }
}
